<template>
  <div class="content">
    <div class="detail-drawer">
      <div class="drawer-title" :style="{'line-height': (mediaModel.mediaName && mediaModel.mediaName.length) > 35 ? '' : '53px'}">
        <div class="drawer-title-icon">
          <i class="el-icon-close" @click="handleCloseDrawer" style="cursor: pointer"></i>
        </div>
        <div class="drawer-title-header">
          <div class="drawer-title-text">
            <div>
              素材:&nbsp;{{ mediaModel.mediaName }}
              <span
                :style="{
                  color:
                    $consts.materialSataisTextColor[mediaModel.checkStatus],
                }"
              >&nbsp;&nbsp;&nbsp;{{ $consts.materialStatisText[mediaModel.checkStatus] }}</span>
            </div>
          </div>
          <div v-if="!isMaterialPackage" class="drawer-operate">
            <el-button icon="el-icon-download" type="text" @click="downLoadMedia"></el-button>
          </div>
        </div>
      </div>
      <el-tabs :tab-position="tabPosition" v-model="activeName" style="height: 100%" class="drawer-tabs">
        <el-tab-pane name="detail">
          <span slot="label">
            <i class="el-icon-view"></i> 详情
          </span>
          <CreativeDetail :mediaModel="mediaModel" @reload-content="$emit('reload-content')" />
        </el-tab-pane>
        <el-tab-pane name="log">
          <span slot="label">
            <i class="el-icon-date"></i> 日志
          </span>
          <div class="drawer-tabs-content">
            <div class="title-text">操作日志</div>
            <Table :props="logTable.props" :header="logTable.header" :data="mediaModel.mediaLogList" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import CreativeDetail from './components/CreativeDetail.vue'

export default {
  components: {
    CreativeDetail,
  },
  props: ['tabActiveName', 'mediaModel'],
  data() {
    return {
      activeName: this.tabActiveName,
      tabPosition: 'left',
      logTable: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '操作时间',
            align: 'left',
            prop: 'createTime',
            'show-overflow-tooltip': true
          },
          {
            label: '操作者',
            align: 'left',
            prop: 'operator',
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (params.userType) {
                return params.userType === 1 ? '管理后台' : params.operator
              } else {
                return '-'
              }
            }
          },
          {
            label: '操作类型',
            align: 'left',
            prop: 'operateType',
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (params.operateType || params.operateType === 0) {
                return this.$consts.operateTypeText[params.operateType]
              } else {
                return '-'
              }
            }
          },
          {
            label: '操作内容',
            align: 'left',
            prop: 'description',
            'show-overflow-tooltip': true
          }
        ],
        data: []
      },
    }
  },
  computed: {
    isMaterialPackage() {
      return this.mediaModel.adMediaClass && this.mediaModel.adMediaClass.mediaFormat === 'json'
    },
  },
  methods: {
    handleCloseDrawer() {
      this.$emit('closeDrawer', true)
    },
    downLoadMedia() {
      this.$service
        .downLoadImgFile({ mediaId: this.mediaModel.mediaId })
        .then((result) => {
          const a = document.createElement('a')
          a.href = result.url
          a.target = '_self'
          a.style.display = 'none'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        })
    },
  },
}
</script>
<style>
:focus {
  outline: 0;
}
</style>
<style lang="stylus" scoped>
.content
  display flex
  flex-direction column
.detail-drawer
  height inherit
.drawer-title
  display flex
  flex-direction row
  align-items center
  height 53px
  /* line-height: 53px; */
.drawer-title-icon
  width 56px
  text-align center
  background rgba(10, 33, 64, 0.831372549019608)
  color #fff
  height 53px
  line-height 53px
.drawer-title-header
  display flex
  justify-content space-between
  width calc(100% - 56px)
.drawer-title-text
  height inherit
  padding 0px 16px
  font-size 14px
.drawer-tabs-content
  margin 0 16px
.drawer-operate
  display flex
  align-items center
  width calc(100% - 630px)
  justify-content flex-end
  padding-right 20px
.drawer-tabs> >>>.el-tabs__header
  margin 0
  padding 0
  width 55px
  border-bottom none
.drawer-tabs> >>>.el-tabs__content
  border-top 1px solid #f0f2f5
  border-left 1px solid #f0f2f5
  height calc(100vh - 60px)
  overflow-y auto
.drawer-tabs> >>>.el-tabs__header .el-tabs__active-bar
  display none
.drawer-tabs> >>>.el-tabs__header .el-tabs__item
  padding 0 !important
  height 53px
.drawer-tabs> >>>.el-tabs__header .el-tabs__item.is-active
  background-color #ff8b00
  color #fff
.drawer-tabs> >>>.el-tabs__header .el-tabs__item :hover
  color rgba(0, 0, 0, 0.65)
.drawer-tabs> >>>.el-tabs__header .el-tabs__item span
  font-size 14px
  display flex
  flex-direction column
  align-items center
  justify-content center
  width 56px
  height 53px
  line-height 2
  font-weight bold
.drawer-tabs>>>.tab-left
  width 100%
  display flex
  height 100%
</style>
